// src/data/projectData.js

const projectData = [
    {
      id: 'ai-voice-engine',
      title: 'AI Voice Engine',
      shortDesc: 'A modular voice automation system built by Bularis Tech, with AI conversation, speech processing, call workflows, and local lead capture.',
      fullDesc: 'AI Voice Engine explores how conversational AI, speech recognition, speech synthesis, and telephony can work together in a modular voice automation system. Bularis Tech developed the call handling, audio processing, conversation management, and local lead capture workflows. The project has been exercised in local test-call workflows and remains an engineering foundation for business-specific implementations.',
      eyebrow: 'Developed product · Engineering project',
      objective: 'Build a modular foundation for voice-led business workflows, connecting spoken conversations to AI responses and controlled telephony sessions.',
      capabilities: [
        { title: 'Conversational AI', description: 'Generate spoken responses with a local language model and maintain bounded context during a call.' },
        { title: 'Speech processing', description: 'Transcribe caller audio and synthesize assistant speech through replaceable speech components.' },
        { title: 'Call workflow control', description: 'Manage call states, audio transport, playback, cancellation, and session cleanup through a telephony interface.' },
        { title: 'Local lead capture', description: 'Support deterministic lead questions and save approved callback details to a local database.' },
      ],
      engineering: [
        'Connected Asterisk telephony sessions with an external media stream and a per-call conversation controller.',
        'Built audio framing, speech turn detection, transcription, AI response generation, and speech playback as separate components.',
        'Added call cancellation and cleanup behavior, bounded conversation context, call review records, and local lead capture.',
        'Created local dashboard and test-call workflows to exercise and inspect the system during development.',
      ],
      status: 'Development project. Core voice flows have been exercised in local test-call workflows; each business deployment, telephony setup, and integration requires separate scoping and validation.',
      limitations: [
        'The current call experience is half-duplex; full interruption-aware barge-in is not implemented.',
        'Automatic outbound dialing to external phone numbers is not implemented in the engine.',
        'CRM, calendar, appointment scheduling, and external business-system integrations require additional implementation and validation.',
      ],
      indexable: true,
    },
    {
      id: 1,
      title: 'Genix Flooring Wishlist App',
      image: 'https://via.placeholder.com/400x300',
      shortDesc: 'Custom Shopify app for managing wishlists on a flooring store.',
      fullDesc: 'Built a fully integrated wishlist Shopify app tailored for Genix Flooring, with persistent user sessions, design matching theme branding, and backend logic using Shopify APIs.',
    },
    {
      id: 2,
      title: 'JazzCash Payment Gateway App',
      image: 'https://via.placeholder.com/400x300',
      shortDesc: 'Custom payment app for Shopify using JazzCash API.',
      fullDesc: 'Created a Shopify app for integrating JazzCash as a payment method across stores, using Remix, PayFast integration, and Shopify App Bridge for secure checkout handling.',
    },
    {
      id: 3,
      title: 'Moonies Custom Shopify Store',
      image: 'https://via.placeholder.com/400x300',
      shortDesc: 'POD store built for Moonies brand with personalized artwork display.',
      fullDesc: 'Developed a personalized POD art store where product frames change dynamically based on selected size, using custom JavaScript and Shopify Liquid for dynamic UI logic.',
    },
    {
      id: 4,
      title: 'Typeform AI Product Sorter',
      image: 'https://via.placeholder.com/400x300',
      shortDesc: 'Typeform + OpenAI + Shopify integration for personalized shopping.',
      fullDesc: 'Built a Shopify integration that uses Typeform answers and OpenAI to generate personalized product suggestions and dynamically sort them on the storefront.',
    }
  ];
  
  export default projectData;
